export default __webpack_public_path__ + "static/media/STLCoverLetterInvestorpresentation.9bd3291e.pdf";